import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlocks"><Path fillRule="evenodd" clipRule="evenodd" d="M11 13H17V21H3V7H11V13ZM11 19H15V15H11V19ZM5 13H9V9H5V13Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 11H13V3H21V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlocks;
